module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "region"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Which area(s) of Africa do you want to make change happen in?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search for a country...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.CentralCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showCen
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showCen')
      }
    }
  }, [_vm._v("Central Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCen),
      expression: "showCen"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.CentralCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.NorthCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showNor
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showNor')
      }
    }
  }, [_vm._v("North Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNor),
      expression: "showNor"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.NorthCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.EastCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showEas
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showEas')
      }
    }
  }, [_vm._v("East Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEas),
      expression: "showEas"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.EastCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.SouthCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showSou
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showSou')
      }
    }
  }, [_vm._v("South Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSou),
      expression: "showSou"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.SouthCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.WestCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showWes
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showWes')
      }
    }
  }, [_vm._v("West Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWes),
      expression: "showWes"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.WestCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change focus area")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), (_vm.showTip) ? _c('p', {
    staticClass: "tip"
  }, [_vm._v("(Optional) You can choose as many regions as you like.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241f973b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-6.vue
// module id = 690
// module chunks = 1